(function() {
	ko.components.register('player', {
		template: { element: 'template-player' },
		viewModel: {
			createViewModel: function(params) {
				return params.app.$player;
			}
		}
	});
})();
